module.exports = __webpack_public_path__ + "img/poster-wakethetown2.bf23f65f.png";